const dict = {
  uk: {
    profile: 'Профіль',
    schedule: 'Розклад',
    students: 'Студенти',
    presentations: 'Презентації',
    chat: 'Чат',
    finance: 'Фінанси',
    homework: 'Домашні завдання',
    materials: 'Матеріали',
    programs: 'Програми',
    reader: 'Читанка',
    library: 'Бібліотека',
    games: 'Ігри',
    achievements: 'Досягнення',
    notifications: 'Сповіщення',
  },
  en: {
    profile: 'Profile',
    schedule: 'Schedule',
    students: 'Students',
    presentations: 'Presentations',
    chat: 'Chat',
    finance: 'Finance',
    homework: 'Homework',
    materials: 'Materials',
    programs: 'Programs',
    reader: 'Reader',
    library: 'Library',
    games: 'Games',
    achievements: 'Achievements',
    notifications: 'Notifications',
  },
};

export default dict;
